import { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';
import { DisplayText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const LocationsGroupTitle = (
  props: ComponentProps<typeof DisplayText>,
) => {
  const { children, ...restProps } = props;

  return (
    <View style={styles.container}>
      <DisplayText sizeMatch={['16']} bold {...restProps}>
        {children}
      </DisplayText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: theme.spacing['2'],
    marginBottom: theme.spacing['2'],
  },
});
